/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-restricted-globals */
import Axios from 'axios';
import Cookies from 'js-cookie';
import moment from 'moment';
import React, {
  useCallback,
  useEffect,
  useLayoutEffect,
  useState,
} from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { BrowserRouter as Router, Redirect, Route } from 'react-router-dom';
import SubTabComponent from '../components/SubTab';
import AppLayout from '../components/layouts';
import * as SERVICE from '../constants/service.types';
import * as SYSTEM from '../constants/system.keys';
import { useInActiveLogout } from '../hooks/useInActiveLogout';
import HoasenLogo from '../assets/favicon/hoasen_logo.png';
import {
  authLogoutThunk,
  changeLocales,
  getPublicIpReturn,
  socketEmitEvent,
  updateNamespace,
} from '../redux/actions';
import { resetDataToken } from '../redux/socket';
import AppRoutes from '../routes';
import Login from './auth/Login';
import storageService from '../services/storage.service';
import CryptoJS from 'crypto-js';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import Spinner from '../components/Spinner';

const OPEN_PAGES = 'OPEN_PAGES';
const PAGE_AVAILABLE = 'PAGE_AVAILABLE';
const HOST_NAME = window.location.hostname;
const TITLE_APP = {
  'cloudcam1.hoasengroup.vn': 'Hoa Sen Group',
  'cloudcam.dashhome.vn': 'DashHome',
};
const ICON_APP = {
  'cloudcam1.hoasengroup.vn': HoasenLogo,
};

export default function App() {
  const { i18n } = useTranslation();
  const dispatch = useDispatch();
  const { isAuth, socketState, language, namespace, namespaces, dataUser } =
    useSelector((state) => state);
  const [isLogin, setIsLogin] = useState(false);
  const [isBlockDevTool, setIsBlockDevTool] = useState(false);
  const [isOpenPage, setIsOpenPage] = useState(false);
  const [current] = useState(Date.now());
  const [mainTabKey, setMainTabKey] = useState(Date.now());
  const authSessionLogout = localStorage.getItem(SYSTEM.AUTO_LOGOUT_SESSION);
  const allowMultiTab = +localStorage.getItem(SYSTEM.ALLOW_MULTI_TABS);
  const [isInitialSetup, setIsInitialSetup] = useState(false); //Decode auth_token and set to storageService

  const initialSetup = useCallback(async () => {
    localStorage.removeItem('auth_token'); //remove old access token
    
    const fp = await FingerprintJS.load();
    const { visitorId } = await fp.get();

    const encryptedToken = localStorage.getItem(SYSTEM.TOKEN) || '';
    try {
      storageService.setInternalStorage({
        fingerPrintKey: visitorId,
        decodedAccessToken: encryptedToken
          ? CryptoJS.AES.decrypt(encryptedToken, visitorId).toString(
              CryptoJS.enc.Utf8
            )
          : '',
      });
      
      setIsInitialSetup(true);
    } catch (error) {
      storageService.setInternalStorage({
        fingerPrintKey: visitorId,
      });
      setIsInitialSetup(true);
    }
    
  }, []);

  useLayoutEffect(() => {
    initialSetup();
  }, [initialSetup]);

  useInActiveLogout();
  // Block inspect
  useEffect(() => {
    const handleKeyDown = (e) => {
      // Disable F12 and certain key combinations (F12, Ctrl+Shift+I, etc.)
      if (
        isBlockDevTool &&
        (e.key === 'F12' || (e.ctrlKey && e.shiftKey && e.key === 'I'))
      ) {
        e.preventDefault();
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isBlockDevTool]);
  useEffect(() => {
    const blockDevTool = !!dataUser?.enableWatermark;
    setIsBlockDevTool(blockDevTool);
  }, [dataUser]);
  //Block right click
  useEffect(() => {
    const handleRightClick = (e) => {
      if (isBlockDevTool) {
        e.preventDefault();
      }
    };

    window.addEventListener('contextmenu', handleRightClick);

    return () => {
      window.removeEventListener('contextmenu', handleRightClick);
    };
  }, [isBlockDevTool]);
  useEffect(() => {
    if (!isOpenPage) {
      setIsOpenPage(true);
      if (typeof window !== 'undefined') {
        setMainTabKey(current);
        localStorage.setItem(OPEN_PAGES, current);
      }
      window.addEventListener('storage', (e) => {
        if (e.key === OPEN_PAGES) {
          setMainTabKey(parseInt(e.newValue));
          localStorage.setItem(PAGE_AVAILABLE, current);
        }
        if (e.key === PAGE_AVAILABLE) {
        }
      });
    }
  }, [current, isOpenPage]);

  const onMainTabChange = useCallback(() => {
    setMainTabKey(current);
    localStorage.setItem(OPEN_PAGES, current);
  }, [current]);

  useEffect(() => {
    const beforeUnloadHandler = (event) => {
      event.preventDefault();
      event.returnValue = '';
      resetDataToken();
      dispatch(authLogoutThunk());
    };

    if (authSessionLogout == 1) {
      window.addEventListener('beforeunload', beforeUnloadHandler);
    }

    return () => {
      window.removeEventListener('beforeunload', beforeUnloadHandler);
    };
  }, [authSessionLogout, dispatch]);

  useEffect(() => {
    async function getPublicIp(cb) {
      try {
        let result = await Axios.get(SYSTEM.CHECK_IP_URL);
        if (result.status === 200) {
          return cb(result.data);
        }
        return cb(null);
      } catch (error) {
        return false;
      }
    }
    getPublicIp((publicIp) => {
      return dispatch(getPublicIpReturn(publicIp));
    });
  }, [dispatch]);

  useEffect(() => {
    let localLanguage = localStorage.getItem(SYSTEM.LANGUAGE);
    if (!localLanguage || localLanguage.length === 0) {
      localLanguage = 'en';
    }
    dispatch(changeLocales(localLanguage));
  }, [dispatch]);

  useEffect(() => {
    if (isInitialSetup) {
      const token = storageService.getInternalStorageByKey(
        SYSTEM.DECODED_ACCESS_TOKEN
      );
      if (token) {
        if (socketState === 1 && language) {
          let dataBody = {
            language,
            accessToken: token,
            appId: SYSTEM.APP_ID,
            encrypted: 1,
            agent: `${window.navigator.userAgent}_web`,
          };

          let dataObj = {
            appServiceType: SERVICE.AUTHENTICATION,
            requestId: new Date().getTime(),
            body: JSON.stringify(dataBody),
          };
          dispatch(socketEmitEvent(dataObj));
        }
      } else {
        resetDataToken();
        dispatch(authLogoutThunk());
      }
    }
  }, [dispatch, language, socketState, isInitialSetup]);

  useEffect(() => {
    if (isAuth === -1) {
      setIsLogin(false);
    } else if (isAuth === 1 && namespaces && namespaces.length > 0) {
      let data = {
        clientId: localStorage.getItem('onesignal_userId'),
        bundleId: 'camera.beex.vn',
        type: 3,
        namespace: namespaces[0],
      };
      let dataObj = {
        appServiceType: SERVICE.REGISTER_NOTIFICATION,
        requestId: new Date().getTime(),
        body: JSON.stringify(data),
      };
      dispatch(socketEmitEvent(dataObj));

      if (namespaces.length === 1) {
        dispatch(updateNamespace(namespaces[0]));
      } else {
        let namespace = localStorage.getItem(SYSTEM.NAMESPACE);
        if (namespace) {
          dispatch(updateNamespace(namespace));
        }
      }
    }
  }, [dispatch, isAuth, namespaces, namespace]);

  useEffect(() => {
    if (isAuth === 1) {
      let data = {};
      let dataObj = {
        appServiceType: SERVICE.LIST_NAMESPACE_BY_ACCOUNT,
        requestId: new Date().getTime(),
        body: JSON.stringify(data),
      };
      return dispatch(socketEmitEvent(dataObj));
    }
    return () => {};
  }, [dispatch, isAuth]);

  useEffect(() => {
    if (isAuth === 1 && namespace) {
      setIsLogin(true);
    }
  }, [isAuth, namespace]);

  useEffect(() => {
    if (language) {
      moment.locale(language);
      i18n.changeLanguage(language);
      localStorage.setItem(SYSTEM.LANGUAGE, language);
    }
  }, [i18n, language]);
  useEffect(() => {
    document.title = TITLE_APP[HOST_NAME] || 'BeeX';
    const favicon = document.querySelector("link[rel~='icon']");
    if (favicon && ICON_APP[HOST_NAME]) {
      favicon.href = ICON_APP[HOST_NAME];
    }
  }, []);
  return isInitialSetup ? (
    <Router>
      {current === mainTabKey || allowMultiTab ? (
        !isLogin ? (
          <>
            <Route exact path="/login">
              <Login />
            </Route>
            <Redirect
              to={{ pathname: `/login`, state: { query: location.search } }}
            />
          </>
        ) : (
          <AppLayout>{AppRoutes}</AppLayout>
        )
      ) : (
        <SubTabComponent onMainTabChange={onMainTabChange} />
      )}
    </Router>
  ) : (
    <Spinner />
  );
}
